<template>
    <div>
        <slot :openDialog="openDialog"></slot>
    </div>
</template>

<script>
import { defineComponent, onMounted, ref } from 'vue';

export default defineComponent({
    name: 'CalendarListEvent',
    props: {
        event: {
            type: Object,
            required: true,
        },
        opendialog: {
            type: Function,
            required: true,
        }
    },
    setup(props) {
        const dialog = ref(null);

        const openDialog = (() => {
            dialog.value.showModal();

            props.opendialog(props.event);
        });

        onMounted(() => {
            dialog.value = document.getElementById('calendar-popup');
        })

        return {
            openDialog,
        };
    },
});
</script>
